// assets/js/video-block.js
// Autoplay/pause au scroll + lazy load des vidéos/iframes INLINE.
// N'impacte JAMAIS la modale : on exclut [data-modal-video].

let managedVideos = new Set();
let managedIframes = new Set();
let usingGSAP = false;

function safePlay(video) {
  if (video.muted == null) video.muted = true;
  if (!video.hasAttribute('playsinline')) video.setAttribute('playsinline', '');
  // lazy src
  if (!video.src) {
    const dataSrc = video.getAttribute('data-src');
    if (dataSrc) video.src = dataSrc;
  }
  video.play().catch(() => {});
}

function safePause(video) {
  try { video.pause(); } catch (_) {}
}

function loadIframe(container) {
  // container = .js-inline-iframe avec data-src
  if (container.querySelector('iframe')) return;
  const src = container.getAttribute('data-src');
  if (!src) return;
  const iframe = document.createElement('iframe');
  iframe.className = 'w-full h-full';
  iframe.setAttribute('allowfullscreen', '');
  iframe.setAttribute('allow', 'autoplay; fullscreen; picture-in-picture');
  iframe.src = src;
  container.appendChild(iframe);
}

function initWithScrollTrigger(videos, iframes) {
  const gs = window.gsap;
  const ST = gs && window.ScrollTrigger;
  if (!gs || !ST) return false;

  usingGSAP = true;

  videos.forEach((v) => {
    window.ScrollTrigger.create({
      trigger: v,
      start: 'top 70%',
      end: 'bottom 30%',
      onEnter: () => safePlay(v),
      onEnterBack: () => safePlay(v),
      onLeave: () => safePause(v),
      onLeaveBack: () => safePause(v)
    });
  });

  iframes.forEach((box) => {
    window.ScrollTrigger.create({
      trigger: box,
      start: 'top 80%',
      onEnter: () => loadIframe(box),
    });
  });

  return true;
}

function initWithIntersectionObserver(videos, iframes) {
  if (!('IntersectionObserver' in window)) return false;

  const videoIO = new IntersectionObserver((entries) => {
    entries.forEach((e) => {
      if (e.isIntersecting && e.intersectionRatio >= 0.6) safePlay(e.target);
      else safePause(e.target);
    });
  }, { threshold: [0, 0.6, 1] });

  const iframeIO = new IntersectionObserver((entries) => {
    entries.forEach((e) => {
      if (e.isIntersecting) loadIframe(e.target);
    });
  }, { threshold: [0] });

  videos.forEach((v) => videoIO.observe(v));
  iframes.forEach((b) => iframeIO.observe(b));

  return true;
}

/**
 * @param {Object} options
 *  - selectorVideos : sélectionne UNIQUEMENT les vidéos inline à gérer
 *  - selectorIframes: sélectionne les containers d'iframe inline à lazy-load
 */
export function initHiTechVideoBlocks(options = {}) {
  const selVideos  = options.selectorVideos  || 'video[data-autoplay-on-scroll]:not([data-modal-video])';
  const selIframes = options.selectorIframes || '.js-inline-iframe[data-src]';

  const videos  = Array.from(document.querySelectorAll(selVideos));
  const iframes = Array.from(document.querySelectorAll(selIframes));

  if (!videos.length && !iframes.length) return;

  videos.forEach((v) => managedVideos.add(v));
  iframes.forEach((b) => managedIframes.add(b));

  // 1) GSAP si dispo
  const okGSAP = initWithScrollTrigger(videos, iframes);
  if (okGSAP) {
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) managedVideos.forEach(safePause);
    });
    return;
  }

  // 2) Fallback IO
  const okIO = initWithIntersectionObserver(videos, iframes);
  if (okIO) {
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) managedVideos.forEach(safePause);
    });
    return;
  }

  // 3) Rien (on évite le scroll listener pour les perfs)
  // console.warn('[video-block] ni ScrollTrigger ni IntersectionObserver disponibles.');
}

// Coordination avec la modale : pause globale pendant la modale
document.addEventListener('hitech:modal-open', (e) => {
  if (e.detail?.type === 'video') managedVideos.forEach(safePause);
});
document.addEventListener('hitech:modal-close', (e) => {
  if (e.detail?.type === 'video') {
    // Relance uniquement celles visibles – la lib choisie reprendra la main
    managedVideos.forEach((v) => {
      const r = v.getBoundingClientRect();
      const visible = r.top < window.innerHeight * 0.7 && r.bottom > window.innerHeight * 0.3;
      if (visible) safePlay(v);
    });
    // Si GSAP, on peut raffraîchir le layout
    if (usingGSAP && window.ScrollTrigger) window.ScrollTrigger.refresh();
  }
});
